<br>
<div class="card card-default">
    <div class="card-header title_size">
    <h2 class="card-title">Edit Folder</h2>
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    
    <div class="card-body">

    <div class="row">
    <div class="col-md-6">

      
        <div class="form-group">
            <label>Folder Name</label><span class="error">{{FolderName}}</span>
            <input type="text" class="form-control"  name="cat" [(ngModel)]="FolderDetail.folder_name" (ngModelChange)="valuechange1($event)">
        </div>

        <div class="form-group">
            <label>Parent Folder Name</label>
            <select  class="form-control" style="width: 100%;" data-select2-id="1" tabindex="-1"  aria-hidden="false"  #mySelect (change)="SelectFolder(mySelect.value);">
                <option value="" hidden>{{this.output[0].parent_folder_name}}</option>
                <option *ngFor="let item of parent" [value]="item._id">{{item.folder_name}}</option>                   
               </select> 
        </div>
   
    </div>
    <!---------------------------------------------next row-------------------------------------->
    
    <div class="col-md-6">

            <div class="form-group">
                <label>Relative Folder Name</label>
                <!-- <input type="text" class="form-control"  name="rel" [(ngModel)]="Rel.rel_folder" [readonly]="true"> -->
             
                <ng-multiselect-dropdown name="rel"
                [placeholder]="'Select Folder'"
                [settings]="dropdownSettings"
                [data]="dropdownList"
                allowSearchFilter=true
                (onSelectAll)="onSelectAll($event)"
                [(ngModel)]="selectedItems"
               >
               </ng-multiselect-dropdown>
 
            </div>
        </div>
     
       
        </div>

        <div>
            <h1 class="msg">{{msg1}}</h1>
        </div>
        
        <button type="submit" class="btn btn-primary btn_allign" [disabled]="btnstate" (click)="SubmitUpdate()">Submit</button>

    </div>
    </div>

